import axios from 'axios'
import jwtToken from '@/helpers/getJwtToken'

const PAYMENTS_API_URL = process.env.VUE_APP_PAYMENTS_API_URL

export default axios.create({
  baseURL: `${PAYMENTS_API_URL}/api`,
  headers: {
    Authorization: `Bearer ${jwtToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})
